import { AppSettingsService } from './app-settings.service';

export default angular
  .module('sfMobile.services.app-settings', [])
  .service('appSettingsService', AppSettingsService).name;
